











import { Component, Prop, Emit, Vue } from "vue-property-decorator";
@Component
export default class InputCheckboxComponent extends Vue {
  @Prop()
  id!: string;

  @Prop({
    default: ""
  })
  labelMsg!: string;

  @Prop()
  value!: any;

  @Emit()
  change(value: any) {
    return value;
  }

  get internalValue() {
    return this.value;
  }

  set internalValue(value: any) {
    this.change(value);
  }
}
